import { createSelector } from '@ngrx/store';

import { createReversalAdjustmentState } from './selector';

export const createReversalAdjustmentSelector = createSelector(
  createReversalAdjustmentState,
  (state) => state?.createReversalAdjustment,
);
